// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";

var wrapper = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.display("flex"),
      BsCssJs$PrezzeeRibbon.flexDirection("column"),
      BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(50)),
      BsCssJs$PrezzeeRibbon.justifyContent("center"),
      BsCssJs$PrezzeeRibbon.alignItems("flexEnd"),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletOrMobile, [
            BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.rem(1)),
            BsCssJs$PrezzeeRibbon.justifyContent("center"),
            BsCssJs$PrezzeeRibbon.alignItems("flexStart")
          ])
    ]);

var Styles = {
  wrapper: wrapper
};

function AutomateSimplify__CTAContainer(props) {
  var classname = props.classname;
  var classname$1 = classname !== undefined ? classname : "";
  var wrapper$1 = Classnames([
        wrapper,
        classname$1
      ]);
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: wrapper$1
            });
}

var make = AutomateSimplify__CTAContainer;

export {
  Styles ,
  make ,
}
/* wrapper Not a pure module */
